import React from "react";
import Header from "./Header";
import ApplicantsHub from "../extension/ApplicantsHub";

export default function LayoutApplicantsHub() {
  return (
    <>
      <Header />
      <ApplicantsHub />
    </>
  );
}
